import React, { useContext } from 'react';
import clsx from 'classnames';
import TableContext from './TableContext';
import { Skeleton } from '@/components/Skeleton/Skeleton';

function TableHeaderCell({ column }: { column: any }) {
  const { skeletonWidthMax = 100, skeletonWidthMin = 40 } = column;
  const { key, ...headerProps } = column.getHeaderProps({
    className: clsx(
      'th',
      { [`align-${column.align}`]: column.align },
      column.className,
    ),
  });

  return (
    <div key={key} {...headerProps}>
      <Skeleton minWidth={skeletonWidthMin} maxWidth={skeletonWidthMax} />
    </div>
  );
}

/**
 * Table skeleton rows.
 */
export function TableSkeletonHeader({}) {
  const {
    table: { headerGroups },
  } = useContext(TableContext);

  return (
    <div className="thead">
      {headerGroups.map((headerGroup: any) => {
        const { key, ...groupProps } = headerGroup.getHeaderGroupProps({
          className: 'tr',
        });
        return (
          <div key={key} {...groupProps}>
            {headerGroup.headers.map((column: any) => (
              <TableHeaderCell key={column.id} column={column} />
            ))}
          </div>
        );
      })}
    </div>
  );
}
